module.exports = __webpack_public_path__ + "static/clock.cd8d7116.svg";